import { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapPin } from 'lucide-react';
import { Button } from '../ui/button';

// Fix default Leaflet icon paths (CRA bundles icons as modules)
const DefaultIcon = L.icon({
  iconRetinaUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

function RecenterOnChange({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);
  return null;
}

export default function LocationPicker({ lat, lng, onChange }) {
  const markerRef = useRef(null);
  const center = [lat || 41.9028, lng || 12.4964]; // default Roma

  const handleUseGps = () => {
    if (!navigator.geolocation) {
      alert('Geolocalizzazione non supportata dal browser');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => onChange(pos.coords.latitude, pos.coords.longitude),
      () => alert('Impossibile rilevare la posizione GPS'),
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  const handleDragEnd = () => {
    const m = markerRef.current;
    if (m) {
      const p = m.getLatLng();
      onChange(p.lat, p.lng);
    }
  };

  return (
    <div className="space-y-2" data-testid="location-picker">
      <div className="flex items-center gap-2">
        <Button
          type="button"
          onClick={handleUseGps}
          variant="outline"
          size="sm"
          className="rounded-xl"
          data-testid="use-gps-button"
        >
          <MapPin className="w-4 h-4 mr-1" />
          Usa la mia posizione
        </Button>
        {lat && lng && (
          <span className="text-xs text-slate-500">
            {lat.toFixed(5)}, {lng.toFixed(5)}
          </span>
        )}
      </div>
      <div className="rounded-xl overflow-hidden border border-slate-200" style={{ height: 240 }}>
        <MapContainer
          center={center}
          zoom={lat && lng ? 17 : 13}
          style={{ height: '100%', width: '100%' }}
          scrollWheelZoom
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {lat && lng && (
            <Marker
              position={[lat, lng]}
              draggable
              eventHandlers={{ dragend: handleDragEnd }}
              ref={markerRef}
            />
          )}
          <RecenterOnChange center={lat && lng ? [lat, lng] : null} />
        </MapContainer>
      </div>
      <p className="text-xs text-slate-500">
        Trascina il pin sulla mappa per affinare la posizione esatta del negozio.
      </p>
    </div>
  );
}
